module.exports = __webpack_public_path__ + "site/img/260.54d3fb40.jpg";